// src/app/directives/auto-scale.directive.ts
import {
  Directive,
  ElementRef,
  Input,
  AfterViewInit,
  OnDestroy,
Renderer2
} from '@angular/core';

@Directive({
  selector: '[appAutoScale]',
  standalone: true
})
export class AutoScaleDirective implements AfterViewInit, OnDestroy {

  /** Tasarımın orijinal ölçüsü (px) – gerekirse kart bazında @Input ile değiştir */
  @Input() baseWidth  = 220;
  @Input() baseHeight = 420;

  private ro!: ResizeObserver;

  constructor(private host: ElementRef<HTMLElement>,  private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    const el = this.host.nativeElement;

    // 💡 Ortalama için stil ekle
    this.renderer.setStyle(el, 'display', 'grid');
    this.renderer.setStyle(el, 'place-items', 'center');
    this.renderer.setStyle(el, 'width', '100%');
    this.renderer.setStyle(el, 'height', '100%');
    this.renderer.setStyle(el, 'transform-origin', 'center center');

    this.ro = new ResizeObserver(([entry]) => {
      const { width, height } = entry.contentRect;
      const scale = Math.min(width / this.baseWidth, height / this.baseHeight);
      el.style.transform = `scale(${scale})`;
    });

    // Parent element üzerinden boyut takibi
    this.ro.observe(el.parentElement!);
  }

  ngOnDestroy(): void {
    this.ro.disconnect();
  }
}
